import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";

import { useAuth } from "../../auth/FirebaseAuth";
import { useAppContext } from "../AppContext";
import { getDocDataById, getDocDataByRef } from "../../models/DataFunctions";
import { Loading } from "../../pages/Loading";
import NotFound from "../../pages/NotFound";

import Home from "../../pages/Home";

type OldRoutesProps = {
  navigateWorkspace: any;
  actualpage: any;

  userData: any;
  orgData: any;
  handleLoginAs: any;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
  setShowProtocole?: (page: number) => void; // Optional prop to control protocol visibility
};

const OldRoutes = ({
  navigateWorkspace,
  actualpage,
  userData,
  orgData,
  handleLoginAs,
  handleClickVariant,
  setShowProtocole,
}: OldRoutesProps) => {
  const location = useLocation();

  const navigate = useNavigate(); // Hook to handle navigation
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  if (loading) {
    return (
      <div className="h-screen flex flex-col gap-2 bg-white fixed w-screen items-center justify-center">
        <Loading></Loading>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full ">
      {<div className="mt-6"></div>}
      <Routes>
        <Route
          path="/home"
          element={
            <Home
              userData={userData}
              orgData={orgData}
              setCanFetchFolders={() => {}}
              navigateWorkspace={navigateWorkspace}
              handleClickVariant={handleClickVariant}
            />
          }
        />

        <Route
          path="*"
          element={<NotFound navigateWorkspace={navigateWorkspace} />}
        />
      </Routes>
    </div>
  );
};

export default OldRoutes;
